import { render, staticRenderFns } from "./TheSideNavItem.vue?vue&type=template&id=5a908ee7&scoped=true&"
import script from "./TheSideNavItem.vue?vue&type=script&lang=ts&"
export * from "./TheSideNavItem.vue?vue&type=script&lang=ts&"
import style0 from "./TheSideNavItem.vue?vue&type=style&index=0&id=5a908ee7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a908ee7",
  null
  
)

export default component.exports